<template>
    <img :data-src="src" class="lazy-image" />
  </template>
  
  <script>
  export default {
    props: {
      src: {
        type: String,
        required: true,
      },
    },
    mounted() {
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            observer.unobserve(img);
          }
        });
      });
  
      observer.observe(this.$el);
    },
  };
  </script>
  
  <style scoped>
  .lazy-image {
    /* Opcional: estilos para imágenes de carga y error */
    opacity: 0;
    transition: opacity 0.3s;
  }
  .lazy-image[data-src] {
    opacity: 1;
  }
  </style>  